/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarbonCopy
 */
export interface CarbonCopy {
    /**
     * The email address of the cc recipient to receive a copy of the documents
     * @type {string}
     * @memberof CarbonCopy
     */
    email: string;
    /**
     * The full name of the cc recipient to receive a copy of the documents
     * @type {string}
     * @memberof CarbonCopy
     */
    name: string;
    /**
     * The recipient ID for the cc recipient
     * @type {string}
     * @memberof CarbonCopy
     */
    recipientId: string;
    /**
     * Specifies the signer’s routing order. Lower values are processed earlier. Parallel routing can be achieved by assigning the same order to multiple recipients
     * @type {number}
     * @memberof CarbonCopy
     */
    routingOrder: number;
}

/**
 * Check if a given object implements the CarbonCopy interface.
 */
export function instanceOfCarbonCopy(value: object): boolean {
    if (!('email' in value)) return false;
    if (!('name' in value)) return false;
    if (!('recipientId' in value)) return false;
    if (!('routingOrder' in value)) return false;
    return true;
}

export function CarbonCopyFromJSON(json: any): CarbonCopy {
    return CarbonCopyFromJSONTyped(json, false);
}

export function CarbonCopyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarbonCopy {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'],
        'recipientId': json['recipientId'],
        'routingOrder': json['routingOrder'],
    };
}

export function CarbonCopyToJSON(value?: CarbonCopy | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'name': value['name'],
        'recipientId': value['recipientId'],
        'routingOrder': value['routingOrder'],
    };
}

